import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  FormControl
} from '@material-ui/core';
import {
  ListTableCell,
  ListTableHeaderCell,
  ListTableRow
} from '../../../atoms/Table';
import { useStyles } from './useStyles';
import { DeleteButton, EditButton } from '../../../atoms/Button';
import { useHooks } from './useHooks';
import PaginationComponent from '../../../PaginationComponent';
import { Link } from 'react-router-dom';
import { SiteProcessDeleteModal } from '../ProcessDeleteModal';
import { SiteProcessEditModal } from '../ProcessEditModal';
import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  VFC,
  useContext,
  useEffect
} from 'react';
import { getSiteProcessStatusName } from '../../../../utils';
import { SITE_PROCESS_DISPLAY_LIMIT_LIST } from '../../../../const/ProcessConst';
import { SITE_PROCESS_STATUSES } from '../../../../const/Const';
import LoadingIcon from '../../../atoms/LoadingIcon';
import LoadingIconClear from '../../../atoms/LoadingIconClear';
import { BasicSelect } from '../../input/BasicSelect';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';

export type TProps = {
  constructId: number;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  renderSiteProcessDataTrigger?: boolean;
  reRenderSiteProcessData: () => void;
};

export const SiteProcessListView: VFC<TProps> = props => {
  const {
    constructId,
    currentPage,
    setCurrentPage,
    renderSiteProcessDataTrigger,
    reRenderSiteProcessData
  } = props;

  const classes = useStyles();

  // リストのHooks
  const {
    displayLimit,
    handleChangeDisplayLimit,
    siteProcessList,
    pageCount,
    editSiteProcessId,
    setEditSiteProcessId,
    isOpenSiteProcessEditModal,
    setIsOpenSiteProcessEditModal,
    deleteSiteProcessId,
    setDeleteSiteProcessId,
    isOpenSiteProcessDeleteModal,
    setIsOpenSiteProcessDeleteModal,
    createManDayText,
    handleChangeStatus,
    isLoading,
    isLoadingCurrent
  } = useHooks({
    constructId,
    currentPage,
    setCurrentPage,
    renderSiteProcessDataTrigger,
    reRenderSiteProcessData
  });

  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  return (
    <>
      {!isLoading && isLoadingCurrent && (
        <div className={classes.loadingIconClearWrapper}>
          <LoadingIconClear />
        </div>
      )}
      <div className={classes.listContainer}>
        <div className={classes.tableTopContainer}>
          <div style={{ display: 'flex' }}>
            <div style={{ marginRight: 10 }} className={classes.selectBox}>
              <div style={{ paddingLeft: 5 }}>
                <FormControl>
                  <BasicSelect
                    value={displayLimit}
                    onChange={handleChangeDisplayLimit}
                    inputProps={{ 'aria-label': 'age' }}
                    disableUnderline
                  >
                    {SITE_PROCESS_DISPLAY_LIMIT_LIST.map(display_limit => {
                      return (
                        <option value={display_limit} key={display_limit}>
                          {display_limit}件
                        </option>
                      );
                    })}
                  </BasicSelect>
                </FormControl>
              </div>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className={classes.loadingContainer}>
            <LoadingIcon />
          </div>
        )}
        {!isLoading && (
          <>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table>
                <TableHead>
                  <ListTableRow>
                    <ListTableHeaderCell className={classes.headerCellLarge}>
                      大工程
                    </ListTableHeaderCell>
                    <ListTableHeaderCell className={classes.headerCellLarge}>
                      小工程
                    </ListTableHeaderCell>
                    <ListTableHeaderCell className={classes.headerCellMedium}>
                      担当
                    </ListTableHeaderCell>
                    <ListTableHeaderCell
                      className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                    >
                      開始日
                    </ListTableHeaderCell>
                    <ListTableHeaderCell
                      className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                    >
                      終了日
                    </ListTableHeaderCell>
                    {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                      <>
                        <ListTableHeaderCell
                          className={`${classes.headerCellSmall} ${classes.textAlignCenter}`}
                        >
                          タスク
                        </ListTableHeaderCell>
                        <ListTableHeaderCell
                          className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                        >
                          ステータス
                        </ListTableHeaderCell>
                        <ListTableHeaderCell
                          className={`${classes.headerCellSmall} ${classes.textAlignCenter}`}
                        >
                          アラート
                        </ListTableHeaderCell>
                        <ListTableHeaderCell
                          className={classes.headerCellMedium}
                        >
                          計画人工
                        </ListTableHeaderCell>
                        <ListTableHeaderCell
                          className={classes.headerCellMedium}
                        >
                          実働人工
                        </ListTableHeaderCell>
                        {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                          <ListTableHeaderCell></ListTableHeaderCell>
                        )}
                      </>
                    )}
                  </ListTableRow>
                </TableHead>
                <TableBody>
                  {siteProcessList &&
                    siteProcessList.map(siteProcessList => {
                      return (
                        <ListTableRow key={siteProcessList.id}>
                          <ListTableCell
                            className={classes.detailCellWordBreak}
                          >
                            {siteProcessList.parent_site_process_name
                              ? siteProcessList.parent_site_process_name
                              : siteProcessList.site_process_name}
                          </ListTableCell>
                          <ListTableCell
                            className={classes.detailCellWordBreak}
                          >
                            {siteProcessList.parent_site_process_name
                              ? siteProcessList.site_process_name
                              : '--'}
                          </ListTableCell>
                          <ListTableCell
                            className={classes.detailCellWordBreak}
                          >
                            {siteProcessList.charge_user_name || '--'}
                          </ListTableCell>
                          <ListTableCell className={classes.textAlignCenter}>
                            {siteProcessList.start_date}
                          </ListTableCell>
                          <ListTableCell className={classes.textAlignCenter}>
                            {siteProcessList.end_date || '--'}
                          </ListTableCell>
                          {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                            <>
                              <ListTableCell
                                className={classes.textAlignCenter}
                              >
                                <Link
                                  to={{
                                    pathname: `/constructions/${constructId}/tasks`,
                                    state: {
                                      siteProcessId: siteProcessList.id,
                                      listMode: true
                                    }
                                  }}
                                >
                                  {siteProcessList.site_task_count}件
                                </Link>
                              </ListTableCell>
                              <ListTableCell
                                className={classes.textAlignCenter}
                              >
                                <BasicSelect
                                  className={`${classes.selectBox} ${classes.selectBoxInRow}`}
                                  value={siteProcessList.status}
                                  onChange={(
                                    e: ChangeEvent<HTMLSelectElement>
                                  ) => {
                                    handleChangeStatus(e, siteProcessList.id);
                                  }}
                                  disableUnderline
                                >
                                  {SITE_PROCESS_STATUSES.map(value => (
                                    <option value={value} key={value}>
                                      {getSiteProcessStatusName(value)}
                                    </option>
                                  ))}
                                </BasicSelect>
                              </ListTableCell>
                              <ListTableCell
                                className={classes.textAlignCenter}
                              >
                                {siteProcessList.alert_count === 0 ? (
                                  '0件'
                                ) : (
                                  <Link
                                    to={{
                                      pathname: `/constructions/${constructId}/tasks`,
                                      state: {
                                        siteProcessId: siteProcessList.id,
                                        listMode: true,
                                        viewAlert: true
                                      }
                                    }}
                                  >
                                    {siteProcessList.alert_count}件
                                  </Link>
                                )}
                              </ListTableCell>
                              <ListTableCell>
                                {siteProcessList.planned_man_day
                                  ? `${siteProcessList.planned_man_day}人日`
                                  : '--'}
                              </ListTableCell>
                              <ListTableCell>
                                {createManDayText(
                                  siteProcessList.actual_man_day,
                                  siteProcessList.planned_man_day
                                )}
                              </ListTableCell>
                              <ListTableCell>
                                <div className={classes.listTableButtonBox}>
                                  <EditButton
                                    onClick={() => {
                                      setEditSiteProcessId(siteProcessList.id);
                                      setIsOpenSiteProcessEditModal(true);
                                    }}
                                  >
                                    編集
                                  </EditButton>
                                  <DeleteButton
                                    onClick={() => {
                                      setDeleteSiteProcessId(
                                        siteProcessList.id
                                      );
                                      setIsOpenSiteProcessDeleteModal(true);
                                    }}
                                  >
                                    削除
                                  </DeleteButton>
                                </div>
                              </ListTableCell>
                            </>
                          )}
                        </ListTableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            {siteProcessList && siteProcessList.length > 0 && (
              <PaginationComponent
                page={currentPage}
                pageCount={pageCount}
                setCurrentPage={setCurrentPage}
              />
            )}
          </>
        )}
      </div>
      {/* 編集モーダル */}
      <SiteProcessEditModal
        isOpen={isOpenSiteProcessEditModal} //モーダルopenメソッドの初期値
        setIsOpen={setIsOpenSiteProcessEditModal} //モーダルopenメソッドのset値
        siteProcessId={editSiteProcessId} //選んだ工程IDをリクエストとして渡す
        afterUpdate={reRenderSiteProcessData}
        afterDelete={reRenderSiteProcessData} //削除ボタン用
      />

      {/* 削除モーダル */}
      <SiteProcessDeleteModal
        isOpen={isOpenSiteProcessDeleteModal}
        siteProcessId={deleteSiteProcessId}
        setIsOpen={setIsOpenSiteProcessDeleteModal}
        afterSubmit={reRenderSiteProcessData}
      />
    </>
  );
};
